import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/dynamic-pdf-templates/{id}/template-with-assets']['GET'];

type Input = ThisApi['params'];
type Output = ThisApi['response'];

const getDynamicPdfTemplateAndAssetsById = async ({ id }: Input): Promise<Output> => {
  try {
    const response = await formsBackendClient.get(`/dynamic-pdf-templates/${id}/template-with-assets`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch dynamic PDF templates by ID:', error);
    throw error;
  }
};

export default getDynamicPdfTemplateAndAssetsById;
